import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import "../../assets/styles/home/HomePage.css";
import ServiceSection from "./ServiceSection";
import HeroSection from "./HeroSection";
import PortfolioSection from "./PortfolioSection";
import ActionSection from "./ActionSection";
import NewsSection from "./NewsSection";

function HomePage() {
  return (
    <div className="home-page">
      <HeroSection />
      <ServiceSection />
      <PortfolioSection />
      <ActionSection />
      <NewsSection />
    </div>
  );
}

export default HomePage;

// import HeroSection from "./HeroSection";
// import FeaturesSection from "./FeaturesSection";
// import React, { useContext } from "react";
// import { AppContext } from "../../context/AppContext";
// import { Button } from "react-bootstrap";
// import "../../assets/styles/HomePage.css";

// function HomePage() {
//   const { state, setState } = useContext(AppContext);
//   return (
//     <div>
//       <HeroSection />
//       <FeaturesSection />
//       <p>Current theme: {state.theme}</p>
//       <button onClick={() => setState({ ...state, theme: "dark" })}>
//         Switch to Dark Theme
//       </button>

//       <Button variant="primary">Primary Button</Button>

//       <div className="home-page">
//         <h1>Welcome to Our Company</h1>
//         <p>This is the homepage of our company website.</p>
//       </div>
//     </div>
//   );
// }
